<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useDownloadPlatformIdCard } from "~/modules/license/composables/useDownloadPlatformIdCard";
import { useOrganizationStore } from "~/modules/organization/stores/useOrganizationStore";
import ILxcDownload from "~icons/lxc/download";
import ILxcInfo from "~icons/lxc/info";

const { t } = useI18n();

const { currentOrganization } = storeToRefs(useOrganizationStore());

const {
  downloadPlatformIdCard,
  isLoading: isLoadingDownloadIdCard,
  canDownloadPlatformIdCard,
} = useDownloadPlatformIdCard(currentOrganization.value?.code);
</script>

<template>
  <div class="flex border border-gray-300 rounded-lg mt-6 p-4 relative">
    <div
      class="border border-gray-300 rounded-lg p-2 mr-4 text-gray-500 justify-center items-center"
    >
      <i-lxc-info height="1.5em" width="1.5em" />
    </div>
    <div>
      <div class="font-semibold">
        {{ t("license.idCard.title") }}
      </div>
      <div>{{ t("license.idCard.description") }}</div>
    </div>
    <div class="absolute right-4">
      <lxc-button
        v-if="canDownloadPlatformIdCard()"
        type="tertiary"
        :title="t('license.idCard.export.title')"
        :icon="ILxcDownload"
        :is-loading="isLoadingDownloadIdCard"
        @click="downloadPlatformIdCard"
      >
        {{ t("license.idCard.export.text") }}
      </lxc-button>
    </div>
  </div>
</template>
